import { render, staticRenderFns } from "./op-data-comand-buttons.vue?vue&type=template&id=5b34a594&scoped=true"
import script from "./op-data-comand-buttons.ts?vue&type=script&lang=js&external"
export * from "./op-data-comand-buttons.ts?vue&type=script&lang=js&external"
import style0 from "./op-data-comand-buttons.less?vue&type=style&index=0&id=5b34a594&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34a594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b34a594')) {
      api.createRecord('5b34a594', component.options)
    } else {
      api.reload('5b34a594', component.options)
    }
    module.hot.accept("./op-data-comand-buttons.vue?vue&type=template&id=5b34a594&scoped=true", function () {
      api.rerender('5b34a594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/op-data-comand-buttons/op-data-comand-buttons.vue"
export default component.exports